// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"Label_clearfix__3QCfr","ellipsis":"Label_ellipsis__1lvhQ","hide":"Label_hide__3iMcQ","label":"Label_label__tpPkF"};